// extracted by mini-css-extract-plugin
var _1 = "GvR2q";
export { _1 as "buttons" }
